/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlBulkReportAssetsResult } from './ControlBulkReportAssetsResult';
import {
    ControlBulkReportAssetsResultFromJSON,
    ControlBulkReportAssetsResultFromJSONTyped,
    ControlBulkReportAssetsResultToJSON,
} from './ControlBulkReportAssetsResult';

/**
 * 
 * @export
 * @interface ControlBulkReportAssetsResponse
 */
export interface ControlBulkReportAssetsResponse {
    /**
     * 
     * @type {Array<ControlBulkReportAssetsResult>}
     * @memberof ControlBulkReportAssetsResponse
     */
    results: Array<ControlBulkReportAssetsResult>;
    /**
     * 
     * @type {number}
     * @memberof ControlBulkReportAssetsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ControlBulkReportAssetsResponse
     */
    succeeded: number;
    /**
     * 
     * @type {number}
     * @memberof ControlBulkReportAssetsResponse
     */
    failed: number;
}

/**
 * Check if a given object implements the ControlBulkReportAssetsResponse interface.
 */
export function instanceOfControlBulkReportAssetsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "succeeded" in value;
    isInstance = isInstance && "failed" in value;

    return isInstance;
}

export function ControlBulkReportAssetsResponseFromJSON(json: any): ControlBulkReportAssetsResponse {
    return ControlBulkReportAssetsResponseFromJSONTyped(json, false);
}

export function ControlBulkReportAssetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBulkReportAssetsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ControlBulkReportAssetsResultFromJSON)),
        'total': json['total'],
        'succeeded': json['succeeded'],
        'failed': json['failed'],
    };
}

export function ControlBulkReportAssetsResponseToJSON(value?: ControlBulkReportAssetsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ControlBulkReportAssetsResultToJSON)),
        'total': value.total,
        'succeeded': value.succeeded,
        'failed': value.failed,
    };
}

